import { useContext, useMemo } from 'react'
import { GlobalStoreContext } from 'stores/GlobalStore'

export const useOneStop = () => {
  const globalStore = useContext(GlobalStoreContext)
  const updatePhase = (phase: number, updateRegistration = false) => {
    globalStore?.setState({
      ...globalStore?.state,
      oneStop: {
        updateRegistration,
        phase,
      },
    })
  }
  return {
    goToMailInBallot: () => {
      updatePhase(2)
    },
    goToPlanToVote: (subPage?: 'polls' | 'early' | 'return') => {
      if (subPage) {
        window.history.pushState(
          {},
          '',
          window.location.pathname.replace(/\/$/, '') +
            '/' +
            subPage +
            window.location.search,
        )
      }
      updatePhase(3)
    },
    updateRegistration: () => {
      updatePhase(1, true)
    },
    isOneStop: useMemo(() => {
      const oneStop = new URLSearchParams(window.location.search).get(
        'one-stop',
      )
      return window.votepaFormId === 'one_stop' || oneStop !== null
    }, []),
  }
}
